import { HTTP } from '@/services/axios';

export async function getSysLogs({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/SysLogs/getBasicList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}
